import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/ExploreButtons.css';

const ExploreButtons = () => {
  const categories = [
    { type: 'SteamGame', label: 'Explore Steam Game Collection', icon: '/static/icons/steam.svg' },
    { type: 'PSPGame', label: 'Explore PSP Game Collection', icon: '/static/icons/gamepad-solid.svg' },
    { type: 'VitaGame', label: 'Explore VITA Game Collection', icon: '/static/icons/playstation.svg' },
    { type: 'NDSGame', label: 'Explore NDS Game Collection', icon: '/static/icons/nintendo-ds.svg' },
    // { type: 'SwitchGame', label: 'Explore Nintendo Switch Game Collection', icon: '/static/icons/nintendoswitch.svg' },
    { type: 'Anime', label: 'Explore Anime Collection', icon: '/static/icons/clapperboard-solid.svg' },
    { type: 'Manga', label: 'Explore Manga Collection', icon: '/static/icons/book-solid.svg' },
    { type: 'Vinyl', label: 'Explore Vinyl Record Collection', icon: '/static/icons/record-vinyl-solid.svg' },
    { type: 'CD', label: 'Explore CD Collection', icon: '/static/icons/compact-disc-solid.svg' },
  ];

  return (
    <div className="explore-buttons">
      <h2>Explore Categories</h2>
      {categories.map((cat) => (
        <Link key={cat.type} to={`/media-list/${cat.type}`} className="explore-button">
          <img src={cat.icon} className="icon" alt={cat.label} />
          {cat.label}
        </Link>
      ))}
    </div>
  );
};

export default ExploreButtons;